import { Switch } from '@pickleballinc/ui/components/ui/switch';
import { Controller, useFormContext } from 'react-hook-form';

interface ToggleButtonFormProps {
	name: string;
	defaultValue?: boolean;
	isDisabled?: boolean;
}

export default function ToggleButtonForm({ name, defaultValue, isDisabled = false }: ToggleButtonFormProps) {
	const { control } = useFormContext();

	return (
		<Controller
			control={control}
			name={name}
			defaultValue={defaultValue}
			render={({ field }) => (
				<Switch
					{...field}
					id={name}
					disabled={isDisabled}
					checked={field.value}
					onCheckedChange={(checked) => {
						field.onChange(checked);
					}}
				/>
			)}
		/>
	);
}
